// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"258199ed","316":"5d759033"}[chunkId] + ".chunk.css";
};